import { coverxAPI, realAxiosInstance } from './api'

const whichAlternative = window.location?.href.includes(
  'motortrade-roadrisks-s2-rtl'
)
  ? 'motortrade-roadrisks-s2-rtl'
  : window.location?.href.includes('motortrade-roadrisks-rtl')
    ? 'motortrade-roadrisks-rtl'
    : window.location?.href.includes('motortrade-roadrisks-s2')
      ? 'motortrade-roadrisks-s2'
      : 'motortrade-roadrisks'

const alternateAcronyms = window.location?.href.includes(
  'motortrade-roadrisks-s2-rtl'
)
  ? 'mt-rr-s2-rtl'
  : window.location?.href.includes('motortrade-roadrisks-rtl')
    ? 'mt-rr-rtl'
    : window.location?.href.includes('motortrade-roadrisks-s2')
      ? 'mt-rr-s2'
      : 'mt-rr'

export const getMotorTradeOptions = () => {
  return coverxAPI.get('/funnel/motortrade-roadrisks/options')
}

export const validateDrivers = (params: { data: any }) => {
  return coverxAPI.post(
    `/funnel/motortrade-roadrisks/${alternateAcronyms}/validate-drivers`,
    {
      ...params.data,
    }
  )
}

export const getMTEmail = () => {
  const base = window.location.pathname.includes('/broker/')
    ? 'broker'
    : 'back-office'

  return realAxiosInstance.get(`/${base}/logged-user`)
}

interface IVehicleLookup {
  regNumber: string
}

export const vehicleLookup = (params: IVehicleLookup) => {
  return realAxiosInstance.get(`/vehicle-lookup/${params.regNumber}`)
}

export const roadRiskSubmit = (params: any) => {
  return realAxiosInstance.post(`broker/${whichAlternative}/submit`, {
    ...params,
  })
}

export const brokerMakeAdjustment = (params: any) => {
  return realAxiosInstance.post(
    `broker/${whichAlternative}/submit/${params?.guid}`,
    {
      ...params.data,
    }
  )
}

export const MTBackOfficeMTA = (params: any) => {
  // Backoffice - Make Adjustment
  return realAxiosInstance.post(
    `/back-office/quotes/${whichAlternative}/submit/${params?.guid}`,
    {
      ...params.data,
    }
  )
}

export const roadRiskNewQuoteSubmit = (params: any) => {
  return realAxiosInstance.post(
    `back-office/quotes/${whichAlternative}/submit/new/${params?.brokerId}`,
    {
      ...params.data,
    }
  )
}

// Guid
export const getDataWithMTGuid = (guid: string) => {
  return realAxiosInstance.get(`/broker/${whichAlternative}/${guid}`)
}

export const getDataWithMTGuidBackoffice = (guid: string) => {
  return realAxiosInstance.get(`/back-office/${whichAlternative}/${guid}`)
}

export const getDataForClone = (guid: string) => {
  return realAxiosInstance.get(`/back-office/${whichAlternative}/clone/${guid}`)
}

// TODO => check for the api request
// TODO => check for the api request
export const getClientDataWithGuidMT = (clientId: string) => {
  return realAxiosInstance.get(
    `/back-office/${whichAlternative}/client/${clientId}`
  )
}

// TODO => check for the api request
// TODO => check for the api request
export const backOfficeNewQuotesSubmitMT = (params: any) => {
  return realAxiosInstance.post(
    `/back-office/quotes/${whichAlternative}/submit/new/${params?.brokerId}/${params?.clientId || ''}`,
    { ...params.data }
  )
}
